import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import App from "./App";
import "./styles/global.css";

gsap.registerPlugin(ScrollTrigger, useGSAP);

// Stale-deploy recovery. Every route except Home is a lazy() chunk with a
// content hash in its filename. A visitor who loaded the site before a deploy
// and taps a link afterwards asks for a hash that no longer exists on the CDN;
// the SPA fallback used to answer with index.html ("Expected a JavaScript
// module script but the server responded with a MIME type of text/html") and
// React unmounted the whole tree. Vite emits `vite:preloadError` for exactly
// this case — reload once so the browser picks up the new index.html and its
// fresh chunk manifest. The sessionStorage stamp guards against a reload loop
// if the failure is caused by something else (offline, blocked script, …).
window.addEventListener("vite:preloadError", (event) => {
  const KEY = "vite:preloadError:reloadedAt";
  const now = Date.now();
  let last = 0;
  try { last = Number(sessionStorage.getItem(KEY) ?? 0); } catch { /* storage blocked */ }
  if (now - last < 10_000) return; // already retried — let the error surface
  try { sessionStorage.setItem(KEY, String(now)); } catch { /* storage blocked */ }
  event.preventDefault();
  window.location.reload();
});

// StrictMode disabled intentionally: GSAP's useGSAP handles its own cleanup,
// but React 19 StrictMode's double-mount causes ScrollTrigger from()
// states to be stuck. Re-enable later with proper fromTo() patterns.
createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
